import React, { FormEvent, useEffect, useState } from "react";
import { IRepeat } from "../../../types/repeat";
import useUpdateRepeat from "../../../hooks/repeat/useUpdateRepeat";
import useCreateRepeat from "../../../hooks/repeat/useCreateRepeat";
import useDeleteRepeat from "../../../hooks/repeat/useDeleteRepeat";

interface IRepeatProps {
  repeats: IRepeat[];
  currOption: number[];
  setCurrOption: React.Dispatch<React.SetStateAction<number[]>>;
  isDelete: boolean;
  setIsDelete: React.Dispatch<React.SetStateAction<boolean>>;
  setIsOpenDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
}
const Repeat = ({
  repeats,
  currOption,
  setCurrOption,
  isDelete,
  setIsDelete,
  setIsOpenDeleteModal,
}: IRepeatProps) => {
  //eslint-disable-line

  const repeatId = currOption[0] || 0;
  const [repeat, setRepeat] = useState(repeats[0]);
  const [title, setTitle] = useState<string>("");
  const [isProcessRunning, setIsProcessRunning] = useState<boolean>(false);
  const [isServiceError, setIsServiceError] = useState<string | null>(null); //eslint-disable-line

  const blankRepeat: IRepeat = {
    name: "",
    max: 0,
    min: 0,
  };

  useEffect(() => {
    if (repeatId === repeats.length) {
      setRepeat({ ...blankRepeat });
      setTitle("New repeat");
    } else {
      setRepeat(repeats[repeatId]);
      setTitle(repeats[repeatId].name);
    }
  }, [repeatId]); //eslint-disable-line

  const { mutate: updateRepeat } = useUpdateRepeat({
    setIsProcessRunning,
    setIsServiceError,
  });
  const { mutate: createRepeat } = useCreateRepeat({
    setIsProcessRunning,
    setIsServiceError,
  });
  const { mutate: deleteRepeat } = useDeleteRepeat({
    setIsProcessRunning,
    setIsServiceError,
  });

  useEffect(() => {
    if (isDelete) {
      setCurrOption([0]);
      if (repeat.id) deleteRepeat(repeat.id);
      setIsDelete(false);
    }
  }, [isDelete]); //eslint-disable-line

  if (!repeat) {
    return <p>Loading...</p>;
  }

  const handleSave = (e: FormEvent) => {
    e.preventDefault();

    if (repeatId === repeats.length) {
      createRepeat(repeat);
    } else {
      updateRepeat(repeat);
    }
    setTitle(repeat.name);
  };

  const handleDelete = () => {
    if (repeatId === repeats.length) {
      setCurrOption([0]);
      setRepeat(repeats[repeatId]);
    } else {
      setIsOpenDeleteModal(true);
    }
  };

  return (
    <div className="imm_quest_admin__content">
      <div className="content_head">
        <h3>{title}</h3>
      </div>

      <form onSubmit={handleSave} className="content_form">
        <div className="field">
          <label htmlFor="name">Name</label>
          <input
            id="name"
            name="name"
            placeholder="Enter name"
            value={repeat.name}
            onChange={(e) => setRepeat({ ...repeat, name: e.target.value })}
          />
        </div>

        <div className="field">
          <label htmlFor="min">Min</label>
          <input
            id="min"
            name="min"
            type="number"
            placeholder="Enter min"
            value={repeat.min || ""}
            onChange={(e) =>
              setRepeat({ ...repeat, min: parseInt(e.target.value) })
            }
          />
        </div>

        <div className="field">
          <label htmlFor="max">Max</label>
          <input
            id="max"
            name="max"
            type="number"
            placeholder="Enter max"
            value={repeat.max || ""}
            onChange={(e) =>
              setRepeat({ ...repeat, max: parseInt(e.target.value) })
            }
          />
        </div>

        <div className="actions">
          <button className="delete_btn" type="button" onClick={handleDelete}>
            {isProcessRunning ? (
              <i className="imm_quest_admin__process_loader" />
            ) : repeatId === repeats.length ? (
              "Cancel"
            ) : (
              "Delete"
            )}
          </button>
          <button className="save_btn" type="submit">
            {isProcessRunning ? (
              <i className="imm_quest_admin__process_loader" />
            ) : repeatId === repeats.length ? (
              "Create"
            ) : (
              "Save"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Repeat;
